import { memo } from "react";
import { GridActionsCellItem, type GridRowParams } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import { useResourceContext } from "ui/widgets/Resource";

const EditOpenBankingResource = ({ row }: GridRowParams) => {
    const { onOpen } = useResourceContext();

    return (
        <GridActionsCellItem
            onClick={() => onOpen(row)}
            icon={<EditIcon />}
            label='Edit'
        />
    );
};

export default memo(EditOpenBankingResource);
